var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layouts"},[_c('NavBar'),_c('AppMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }